import { useEffect } from "react";
import { useRouteError } from "react-router-dom";
import { useT } from "@/lib/i18n";
import { isModuleLoadError, reloadAfterModuleError, reloadCurrentPage } from "@/lib/module-recovery";

/** Eagerly loaded so recovery does not depend on the failed page chunk or an authenticated session. */
export function AppErrorPage() {
  const error: unknown = useRouteError();
  const t = useT();
  useEffect(() => { reloadAfterModuleError(error); }, [error]);

  return (
    <main className="centered-page" role="alert">
      <h1>{t("common.page_error_title")}</h1>
      <p>{t(isModuleLoadError(error) ? "common.module_error_description" : "common.page_error_description")}</p>
      <button type="button" className="button button--primary" onClick={reloadCurrentPage}>{t("common.reload_page")}</button>
    </main>
  );
}
